import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { GeoAltFill, Whatsapp, EnvelopeFill } from "react-bootstrap-icons";
import { useTiendaConfig } from "../../../hooks/useTiendaConfig";
import getIcon from "../../../utils/getIcon";
import { useCompanyInfo } from "../../../hooks/useCompanyInfo";

const Contact = () => {
    const { socialLinks, whatsappLink } = useTiendaConfig();
    const { companyData } = useCompanyInfo();

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyData.direccion)}`;
    const storeAddress = `${companyData.direccion} ${companyData.ciudad} - ${companyData.departamento}`;

    // Función para obtener URL de WhatsApp válida
    const getWhatsappUrl = () => {
        if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
            return whatsappLink.url;
        }
        return '#';
    };

    return (
        <>
            <div className="py-5 color-bg-secundary">
                <Container>
                    {/* Título */}
                    <div className="text-center mb-5">
                        <h2 className="text-uppercase color-primary mb-3 fs-6 fw-bold">Contacto</h2>
                        <h3 className="fw-bold color-primary     fs-2">¿Tienes preguntas? ¡Escríbenos!</h3>
                        <p className="text-muted mt-3 mx-auto">
                            Estamos disponibles para ayudarte. Contáctanos por cualquiera de nuestros canales.
                        </p>
                    </div>

                    {/* Redes Sociales */}
                    <div className="text-center mb-5">
                        <p className="color-primary mb-3">Síguenos en nuestras redes sociales</p>
                        <div className="d-flex justify-content-center gap-3">
                            {socialLinks.map((link, index) => (
                                <a
                                    key={index}
                                    href={link.url}
                                    rel='noreferrer noopener'
                                    target="_blank"
                                    title={link.title}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        backgroundColor: '#e7e2da',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <span className="color-primary fs-5">{getIcon(link.url)}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Información de Contacto */}
                    <Row className="g-4 justify-content-center">
                        {/* Dirección */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: '#e7e2da' }}
                            >
                                <Card.Body className="text-center color-primary p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#2E0205'
                                        }}
                                    >
                                        <GeoAltFill size={28} className="color-secundary" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">Dirección</Card.Title>
                                    <Card.Text className="text-muted small mb-3">
                                        {storeAddress}
                                    </Card.Text>
                                    <Button
                                        size="sm"
                                        href={googleMapsUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            backgroundColor: '#2E0205',
                                            borderColor: '#2E0205',
                                            color: '#fff'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                    >
                                        Ver en mapa
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* WhatsApp */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: '#e7e2da' }}
                            >
                                <Card.Body className="text-center color-primary p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#2E0205'
                                        }}
                                    >
                                        <Whatsapp size={28} className=" color-secundary" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">WhatsApp</Card.Title>
                                    <Card.Text className="text-muted small mb-3">
                                        Habla con un asesor
                                    </Card.Text>
                                    <Button
                                        size="sm"
                                        href={getWhatsappUrl()}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            backgroundColor: '#2E0205',
                                            borderColor: '#2E0205',
                                            color: '#fff'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                    >
                                        Enviar mensaje
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Correo */}
                        <Col md={4} lg={3}>
                            <Card
                                className="h-100 border-0 shadow-lg"
                                style={{ borderRadius: '16px', backgroundColor: '#e7e2da' }}
                            >
                                <Card.Body className="text-center color-primary p-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            backgroundColor: '#2E0205'
                                        }}
                                    >
                                        <EnvelopeFill size={28} className="color-secundary" />
                                    </div>
                                    <Card.Title className="fw-bold mb-2">Correo</Card.Title>
                                    <Card.Text className="text-muted small mb-3">
                                        Correo corporativo para consultas empresariales.
                                    </Card.Text>
                                    <Button
                                        size="sm"
                                        href={`mailto:${companyData.email}`}
                                        style={{
                                            backgroundColor: '#2E0205',
                                            borderColor: '#2E0205',
                                            color: '#fff'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#2E0205';
                                            e.target.style.borderColor = '#2E0205';
                                        }}
                                    >
                                        Enviar correo
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Contact;
